import React from "react";
import { Alert, View } from "react-native";
import { createPlatformStyles } from "../../theme/theme";
import { useAppSelector } from "@lib";
import FullScreenLoader from "./FullScreenLoader";
import { clearSessionAndLogout } from "@lib/utilities/AuthHelper";
import { useAuth0 } from "@auth0/auth0-react";
import { messages } from "../../resources/strings";
import CustomAlert from "./CustomAlert";
import { ScreenNameList } from "@lib/utilities/Constants";

const MainContainer = ({
  errorData = { message: "", screenName: "" },
  onReloadPress = () => {},
  onEndTimer = () => {},
  children,
  screenName,
  navigation,
}: {
  children: any;
  screenName: string;
  navigation: any;
  errorData: { message: string; screenName: string };
  onReloadPress?: () => void;
  onEndTimer?: () => void;
}) => {
  const { logout } = useAuth0();
  const handleInvalidTokenCase = () => {
    clearSessionAndLogout(navigation, logout);
  };

  const { isConnected } = useAppSelector((state) => state.userReducer);
  const { isLoading } = useAppSelector((state) => state.policyReducer);
  const { loading } = useAppSelector((state) => state.policyDetailReducer);

  const isLoadingViewVisisble = () => {
    if (screenName == ScreenNameList.policyActions) {
      return false;
    }
    return isLoading || loading;
  };
  return (
    <View style={styles.mainContainer} dataSet={{ media: ids?.mainContainer }}>
      <>{children}</>
      {isLoadingViewVisisble() && <FullScreenLoader screenName={screenName} />}
      {errorData.message !== messages.error.noError &&
        !(loading || isLoading) && (
          <CustomAlert
            data={{
              screenName: errorData.screenName,
              message: !isConnected
                ? messages.error.youAreOffline
                : errorData.message,
            }}
            onEndTimer={onEndTimer}
            onReloadPress={onReloadPress}
            onEndLogoutTimer={handleInvalidTokenCase}
          />
        )}
    </View>
  );
};

export default MainContainer;

export const { ids, styles } = createPlatformStyles({
  mobile: {
    mainContainer: { flex: 1, height: "100%", width: "100%" },
  },
  web: { mainContainer: { flex: 1, height: "100%", width: "100%" } },
});
